/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import {
  NOTIFICATION_NUMBER,
  ONESIGNAL_SUBSCRIPTION,
  DOCTOR_ONLINE_DATA,
  DOCTOR_ONLINE_STATE,
  DOCTOR_APPOINTMENT_DATA,
  VIDEO_CALL_DATA,
  SESSION_ID,
  IS_TIMER_TIMEOUT,
  SET_FORUM_READ_TOPICS,
  SET_FORUM_READ_COMMENTS,
  SET_ONLINE_ASSESSMENT_START_STATUS,
  SET_USER_ACCESS,
  PATIENT_QUEUE_COUNT_DATA, CONSTANTS, TOTAL_DOCTORS
} from "../constants/commonConstant";

const initialState = {
  forumReadTopics: 0,
  forumReadComments: 0,
  totalNotification: null,
  oneSignalSubscribed: {},
  doctorOnlineData: {},
  patientsQueueCount: 0,
  doctorOnlineState: true,
  appointmentData: null,
  totalDoctor: 0,
  videoCallData: {
    isCallAccepted: false,
    timerVal: 0
  },
  sessionId: null,
  callTimeoutStatus: false,
  isOnlineAssessmentStarted: false,
  accessGranted: {
    isInstantSwitchAccessGranted: false,
    isInstantConsultAccessGranted: false
  }, constants : {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_NUMBER:
      return {
        ...state,
        totalNotification: action.payload.totalNotification
      };
    case ONESIGNAL_SUBSCRIPTION:
      return {
        ...state,
        oneSignalSubscribed: action.payload
      };
    case TOTAL_DOCTORS:
      console.log("Chanign doctor online state: ", action.payload);
      return {
        ...state,
        totalDoctor: action.payload || 0
      };
    case DOCTOR_ONLINE_DATA:
      return {
        ...state,
        doctorOnlineData: action.payload
      };
    case DOCTOR_ONLINE_STATE:
      console.log("Chanign doctor online state: ", action.payload);
      return {
        ...state,
        doctorOnlineData: action.payload
      };
    case DOCTOR_APPOINTMENT_DATA:
      console.log("Updating Appointment data in store: ", action.payload);
      return {
        ...state,
        appointmentData: action.payload
      };
    case VIDEO_CALL_DATA:
      return {
        ...state,
        videoCallData: Object.assign(
          state.videoCallData ? state.videoCallData : {},
          action.payload
        )
      };
    case SESSION_ID:
      console.log("Storing session id in redux : ", action.payload);
      return {
        ...state,
        sessionId: action.payload
      };
      case CONSTANTS:
      return {
        ...state,
        constants: action.payload
      };
    case IS_TIMER_TIMEOUT:
      return {
        ...state,
        callTimeoutStatus: action.payload
      };
    case SET_FORUM_READ_TOPICS:
      return {
        ...state,
        forumReadTopics: action.payload
      };
      case SET_FORUM_READ_COMMENTS:
      return {
        ...state,
        forumReadComments: action.payload
      };
    case SET_ONLINE_ASSESSMENT_START_STATUS:
      console.log("Hey here: ", action);
      return {
        ...state,
        isOnlineAssessmentStarted: action.payload
      }
    case SET_USER_ACCESS:
      console.log("Setting user access: ", action);
      return {
        ...state,
        accessGranted: action.payload
      }
    case PATIENT_QUEUE_COUNT_DATA:
      console.log("Setting patient queue count data: ", action);
      return {
        ...state,
        patientsQueueCount: action.payload
      }
    default:
      return state;
  }
}

// import { MODEL_SHOW, MODEL_HIDE } from "../constants/commonConstant";

// const initialState = {
//   status: false,
//   title: "",
//   message: ""
// };

// export default function reducer(state = initialState, action) {
//   switch (action.type) {
//     case MODEL_SHOW:
//       return {
//         ...state,
//         status: action.payload.status,
//         title: action.payload.title,
//         message: action.payload.message
//       };
//     case MODEL_HIDE:
//       return {
//         ...state,
//         status: false,
//         title: "",
//         message: ""
//       };
//     default:
//       return state;
//   }
// }
